import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CheckboxItem,
  MaskedTextBlock,
  MoneyBlock,
} from "../../parts/FormBlocks";
import { useState } from "react";
import { RentContractUI, UIValue } from "../../types";

type FinanceFormContractProps = {
  contract: RentContractUI;
  changeContract: (
    key: keyof RentContractUI
  ) => (value: UIValue | string[]) => void;
  onSubmit: () => Promise<void>;
  error: boolean;
};
const FinanceFormContract = ({
  contract,
  changeContract,

  onSubmit,
  error,
}: FinanceFormContractProps) => {
  const [saving, setSaving] = useState(false);

  const addEmail = () => changeContract("emails")([...contract.emails, ""]);

  const updateEmail = (index: number, value: string) => {
    changeContract("emails")([
      ...contract.emails.slice(0, index),
      value,
      ...contract.emails.slice(index + 1),
    ]);
  };

  const deleteEmail = (index: number) => () =>
    changeContract("emails")([
      ...contract.emails.slice(0, index),
      ...contract.emails.slice(index + 1),
    ]);

  const submit = async (event: React.FormEvent) => {
    setSaving(true);
    event.preventDefault();
    await onSubmit();
    setSaving(false);
  };

  return (
    <form className="p-4 flex flex-col gap-4" onSubmit={submit}>
      <MaskedTextBlock
        label="Início do contrato"
        mask="99/99/9999"
        value={contract.startDate}
        onChange={changeContract("startDate")}
      />

      <MaskedTextBlock
        label="Dia do vencimento"
        mask="99"
        value={contract.expirationDay}
        onChange={changeContract("expirationDay")}
      />

      <div className="flex flex-col gap-2 py-2 text-sm">
        <label className="font-bold">Serviços</label>
        <CheckboxItem
          label="Sistema de alarme"
          checked={contract.serviceAlarm}
          onChange={changeContract("serviceAlarm")}
        />

        <CheckboxItem
          label="CFTV"
          checked={contract.serviceCamera}
          onChange={changeContract("serviceCamera")}
        />
      </div>

      <MoneyBlock
        label="Valor mensal"
        value={contract.amount}
        onChange={changeContract("amount")}
      />

      <hr />

      <div className="flex flex-col gap-2">
        <label className="text-sm font-bold">Emails</label>

        {contract.emails.map((email, i) => (
          <div key={i} className="flex flex-col">
            <div className="flex gap-2 text-sm">
              <input
                className="border rounded py-1 px-3 flex-1"
                type="email"
                value={email}
                onChange={(event) => updateEmail(i, event.target.value)}
                required
              />
              <button
                className="border rounded px-2 text-gray-600 hover:bg-slate-50 disabled:text-gray-400 disabled:bg-gray-100 disabled:border-transparent"
                disabled={i === 0}
                onClick={deleteEmail(i)}
              >
                <FontAwesomeIcon icon="trash" />
              </button>
            </div>
          </div>
        ))}

        <div
          className="border rounded py-1 px-3 text-sm hover:bg-slate-50 cursor-pointer text-center"
          onClick={addEmail}
        >
          <FontAwesomeIcon icon="circle-plus" />
        </div>
      </div>

      <hr />

      {error && (
        <div className="text-sm text-red-700 font-bold text-right">
          Erro ao criar contrato
        </div>
      )}

      <div className="text-right">
        <button
          className="rounded py-2 px-4 bg-sky-600 hover:bg-sky-500 font-extrabold text-white"
          disabled={saving}
        >
          Criar
        </button>
      </div>
    </form>
  );
};

export default FinanceFormContract;
